import {LitElement, html} from 'lit-element';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import getRequestWithCallback from '@twebcomponents/web-components-common/js/xhttp/getRequestWithCallback.js';
import JsForCss from '@twebcomponents/web-components-common/js/JsForCSS.js';
import customFilters from '@twebcomponents/web-components-common/js/customFilters.js';
import resizeElementHeight from '@twebcomponents/web-components-common/js/dom/resizeElementHeight.js';
import loadCssForComponent from '@twebcomponents/web-components-common/js/xhttp/loadCssForComponent.js';
import loadTranslationJson from '@twebcomponents/web-components-common/js/xhttp/loadTranslationJson.js';
import TRANS_DICT from './en-Us/trans-dict.js';

class ListTileView extends LitElement {
  static get properties() {
    return {
      accessToken: {
        type: String,
        attribute: 'access-token'
      },
      apiUrl: {
        type: String,
        attribute: 'api-url'
      },
      type: {
        type: String,
        attribute: 'type'
      },
      pageSize: {
        type: String,
        attribute: 'page-size'
      },
      viewType: {
        type: String,
        attribute: 'view-type'
      },
      assetPath: {
        type: String,
        attribute: "asset-path"
      },
      defaultConfig:{
        type:String,
        attribute: "default-config"
      },
      selectedItemId:{
        type:String,
        attribute: "selected-item-id"
      },
      allowMultipleSelect: {
        type: String,
        attribute: 'allow-multiple-select'
      },
      searchByName:{
        type:String,
        attribute: "search-by-name"
      },
      skipRangeInHeader: {
        type: String,
        attribute: "skip-range-in-header",
        value: 'false'
      }
    };
  }
  constructor(defaultAttributes) {
    super();
    this.componentName = 'list-tile-view';
    this.componentCommonUrl = 'https://components.connect.trimble.com/web-components-common/1.2.0';
    this.resourcesUrl = 'https://resources.connect.trimble.com/1.5.0';
    this.apiUrl = "";
    this.accessToken = "";
    this.results = [];
    this.resultsWOFilter = [];
    this.loading = true;
    this.pageSize = 25;
    this.startIndex = 0;
    this.skipRangeInHeader = 'false';
    this.loadNextPage = false;
    this.isEndOfPage = false;
    this.viewType = 'icon';
    this.sort = {'by': 'name', 'order': '+',
                  'queryFormat': 'sort={SORT_ORDER}{SORT_COLUMN}',
                  'regexForReplace': 'sort=[+-]\\w+',
                  'asc': '+', 'desc': '-'};
    this.type = 'projects';
    this.translationDict = TRANS_DICT[this.type];
    this.menus = [
      {'id': "duplicate", 'label': "DUPLICATE", 'click_event_name': 'on-duplicate-menu-click'},
      {'id': "edit", 'label': "EDIT", 'click_event_name': 'on-edit-menu-click'},
      {'id': "leave", 'label': "LEAVE", 'click_event_name': 'on-leave-menu-click'},
      {'id': "delete", 'label': "DELETE", 'click_event_name': 'on-delete-menu-click'},
    ];
    this.columns = [];
    this.thumbnailColumn = {};
    this.titleColumn = {};
    this.hideHeader = true;
    this.sortLoading = false;
    this.noResultIconClass = 'tc-icon-hard-hat';
    this.displayThumbnailAsIcon = false;
    this.defaultThumbnailImage = '/images/project_placeholder.jpg';
    this.includeScrollbar = false;
    this.selectedItemId = null;
    this.searchByName = null;
    this.gridContainerCss = '';
    this.gridCss = 'col-xxl-2 col-lg-3 col-md-4 col-sm-6 col-12';
    this.showCreateButton = true;
    this.includeCustomHeaders = {};
    this.responseKey = '';
    this.skipBearerHeader = false;
    this.allowMultipleSelect = 'false';
    this.addEventListener("load-config-data", function(e){
      this.loadComponentConfig(e.detail);
    }.bind(this));

    defaultAttributes = defaultAttributes || {};
    Object.keys(defaultAttributes).forEach(function(attrKey){
      if( defaultAttributes[attrKey] != null ) {
        this.setAttribute(attrKey, defaultAttributes[attrKey]);
      }
    }.bind(this));
    if( !this.hasAttribute('api-url') && !this.hasAttribute("access-token") ) {
      this.loading = false;
      this.results = [];
      //this.translationDict['NO_RESULT_MESSAGE'] = this.translationDict['NO_REQUIRED_ATTRIBUTE'];
      this.showCreateButton = false;
    }
  }
  connectedCallback() {
    super.connectedCallback();
    if(!this.getAttribute("asset-path")){
      //this.loadCssAndLangJson('./');
      this.assetPath = this.resourcesUrl;
      this.loadCssAndLangJson(this.assetPath);
    }
    window.onresize = function(e){
      if( this.results.length ) {
        resizeElementHeight(this.shadowRoot.querySelector('#view-inner-container'));
      } else {
        this.shadowRoot.querySelector('#view-inner-container').style.height = '100%';
      }
      this.dispatchEvent(new CustomEvent('on-container-height-changed', {detail: {
        'has-records': this.results.length
      }}));
    }.bind(this);
    this.addEventListener("scroll-end", function(){
      if(!this.loading){
        this._triggerScrollEnd();
      }
    }.bind(this));
    this.addEventListener("item-selected", function(e){
      var selectedItem = e.detail.item;
      this.highlightItem(selectedItem.id);
    }.bind(this));
    this.dispatchEvent(new CustomEvent('on-component-ready', {detail: {}}));
  }
  attributeChangedCallback(name, oldValue, newValue) {
    var allowReload = false;
    if(newValue && newValue != 'null' && newValue.indexOf('{{') == -1){
      switch(name){
        case 'access-token':
          this.accessToken = newValue || this.accessToken;
          allowReload = (newValue != oldValue) && this.accessToken;
        break;
        case 'api-url':
          this.apiUrl = newValue || this.apiUrl;
          allowReload = (newValue != oldValue) && this.apiUrl;
        break;
        case 'view-type':
          this.viewType = newValue || this.viewType;
          if( this.results.length ) {
            this.hideHeader = false;
            this.dispatchEvent(new CustomEvent('on-page-items-loaded', {detail: {}}));
            this.dispatchEvent(new CustomEvent('on-container-height-changed', {detail: {
              'has-records': this.results.length
            }}));
          }
        break;
        case 'type':
          this.type = newValue || this.type;
        break;
        case 'asset-path':
          this.assetPath = newValue || this.componentCommonUrl;
          this.loadCssAndLangJson(this.assetPath);
        break;
        case 'default-config':
          this.loadComponentConfig(JSON.parse( newValue));
          //this.requestUpdate('results');
        break;
        case 'selected-item-id':
          this.selectedItemId = newValue || this.selectedItemId;
          if( this.selectedItemId) {
            this.highlightItem(this.selectedItemId);
          }
        break;
        case 'search-by-name':
          this.searchByName = newValue.trim() || null;
          if( this.searchByName ) {
            this.filterResultsByName(this.searchByName);
          } else {
            this.results = this.resultsWOFilter;
            this.requestUpdate('results');
          }
        break;
        case 'skip-range-in-header':
          this.skipRangeInHeader = (newValue == 'true')?  'true': 'false';
          this.requestUpdate('skipRangeInHeader');
        break;
        case 'allow-multiple-select':
          this.allowMultipleSelect = ( newValue == 'true')? 'true' : 'false';
          this.requestUpdate('allowMultipleSelect');
        break;
      }
      if( (name == 'api-url' || name == 'access-token') &&
        this.apiUrl && this.accessToken && allowReload){
        this.results = [];
        this.pageSize = 25;
        this.startIndex = 0;
        this.hideHeader = true;
        this.loading = true;
        this.results = [];
        this.requestUpdate('loading');
        this.requestUpdate('results');
        this.getResults(this.accessToken, true);
      }
    } else if( name == 'search-by-name' && !newValue ) {
      this.results = this.resultsWOFilter;
      this.requestUpdate('results');
    }
  }
render() {
  //For IE jquery + qtip issues
  this.shadowRoot.getAttribute = function() {
    return true;
  }
  this.shadowRoot.exec = function() {
    return true;
  }
  return html`
    <style>
      {{COMP_CSS}}
    </style>
    <style>
      .loader-img {
        width: 24px;
        margin-right: 8px;
      }
      small a {
        font-size: 0.75rem;
      }
      .loading.hide {
        display: none;
      }
      #view-container .tile-dropdown.dropdown-pane.bottom {
        bottom: 78px;
      }
      #view-container .list-dropdown.dropdown-pane.bottom {
        bottom: 42px;
      }
      #view-inner-container {
        width: auto;
      }
      #view-inner-container.scroll {
        overflow-y: auto;
      }
      #view-inner-container.no-scroll {
        overflow: unset;
      }
      .custom-grid > div{
        position:relative;
      }
      .custom-grid .no-col {
        width: 49%;
      }
      .tile .custom-grid .media-object {
        margin-left:1rem;
        margin-right:1rem;
      }
      .tile .custom-grid .media-object .thumbnail img{
        max-width:100%;
        width:100%;
        height:auto;
      }
      .tile .no-col .media-object .thumbnail {
        max-height:6rem;
      }
      .tile .no-col .media-object .thumbnail-wrapper {
        height:6rem;
      }
      .tile .no-col .media-object {
        height:9.5rem
      }
      @media (max-width:576px){
        .tile .custom-grid .no-col{
          width:100%;
        }
      }
      .tile > div{
        width: 100%;
      }
    </style>
    <div id="view-container">
      <div id="view-inner-container" class="container ${this.includeScrollbar && this.results.length ? 'scroll' : 'no-scroll'} ${(this.viewType == 'grid' || this.viewType == 'icon') ? 'tile' : 'table-list  list'} ${this.sortLoading? 'sort-loading' : ''}"  @scroll="${(e) => this._onScrollEnd(e)}">

        ${this.results.length == 0 && !this.loading ? html `${this.renderEmptyView()}` : ''}
        ${ (this.viewType == 'grid' || this.viewType == 'icon') ?
          this.renderGridView() :
          this.renderListView()
        }
        ${this.loading ? html
          `<div class="load-view">
              <img src="${this.resourcesUrl}/images/loading_spinner_dark.svg" class="loader-img">
              <div class="loading ${this.hideHeader? 'show' : 'hide'}">${this.translationDict['LOADING']}..
              </div>
          </div>` : ''
        }
        <div class="end-view">
          ${ this.isEndOfPage ? html
            `<div>${this.translationDict['END_OF_PAGE']}.</div>` : '' }
        </div>
      </div>
    </div>`;
  }
  renderEmptyView() {
    return html `<div class="empty-view">
      <div class="empty">
        ${ this.resultsWOFilter.length == 0 ?
          html`
            <div class="empty-icon">
                <i class="icon-font ${this.noResultIconClass}"></i>
            </div>
            <div class="empty-text">
              <h3 class="text-muted">${this.translationDict['NO_RESULT_FOUND']} &nbsp;</h3>
              ${ this.accessToken && this.apiUrl ?
                html `<small class="text-muted"> ${unsafeHTML(this.translationDict['NO_RESULT_MESSAGE'])} &nbsp;</small>` :
                html `<small class="text-muted">${this.translationDict['NO_REQUIRED_ATTRIBUTE']} &nbsp;</small>`
              }
            </div>
            ${this.showCreateButton ?
            html`<div class="empty-action">
                <button class="button primary" @click="${(e) => this._onMenuClick(e, '', 'on-new-menu-click')}">${this.translationDict['CREATE_NEW']}</button>
            </div>` : ''}
          ` :
          html`<div class="empty-icon">
                <i class="icon-font tc-icon-hard-hat"></i>
            </div>
            <div class="empty-text">
                <h3 class="text-muted">${this.translationDict['NO_SEARCH_RESULT_FOUND']} &nbsp;</h3>
                <small class="text-muted">${this.translationDict['NO_SEARCH_RESULT_MESSAGE']} &nbsp;</small>
            </div>
            <div class="empty-action">
            </div>`
        }
      </div>
    </div>`;
  }
  renderGridView() {
    return html`<div class="row ${this.gridContainerCss}">
      ${this.results.map((item, i) => html`
        <div class="${this.gridCss}">
            <div class="media-object ${item.isActive? 'active': ''} ${item.access === 'NO_ACCESS'? 'locked' : ''}">
              <div class="thumbnail-wrapper" @click="${(e) => this._onItemClick(e, item, i)}">
                ${this.isThumbnailAsImage(item) ?
                  html`<div class="thumbnail no-default-image" style="background-image:url(${this.getThumbnailUrl(item, this.accessToken)})"></div>` :
                  html`<div class="thumbnail default-image">
                    ${ this.displayThumbnailAsIcon? html`
                      <i class="icon-font ${this.displayThumbnailAsIcon}"></i>
                    `: html`<img src="${this.defaultThumbnailImage}"/>` }
                  </div>`
                }
              </div>
              <div class="media-object-section" @click="${(e) => this._onItemClick(e, item, i)}">
                  <div class="media-object-details">
                      <h4 class="ellipsis text-bold"><span>${ item[this.titleColumn.apiPropertyName] || this.getItemValue(item, this.titleColumn.apiPropertyName || 'name' )}</span></h4>
                  </div>
                  ${this.menus.length ?
                  html`<div class="media-object-edit">
                      <ul>
                          <li class="dropdown-pane-container" id="ddp-container-${i}">
                              <button class="button icon-medium icon-circle tertiary dropdownpane-link">
                                  <i class="icon-font tc-icon-more-vert"></i>
                                </button>
                              <div class="dropdown-pane right tile-dropdown">
                                  <ul class="dropdown-list">
                                      ${this.menus.map((menuItem, menuIndex) => html`
                                        <li @click="${(e) => this._onMenuClick(e, item, menuItem.click_event_name)}" class="tooltip12 ellipsis" title="${this.translationDict[menuItem.label]}">${this.translationDict[menuItem.label]}</li>
                                      `)}
                                  </ul>
                              </div>
                          </li>
                      </ul>
                  </div>`: ''}
              </div>
              ${item.access === 'NO_ACCESS'? html`<div class="tile-overlay"  @click="${(e) => this._onItemClick(e, item, i)}">
                                                    <div class="badge dark px-1 py-2">
                                                        <i class="icon-font i16 tc-icon-lock"></i>&nbsp;${this.translationDict["LOCKED"]}
                                                    </div>
                                                </div>` : ''}
            </div>
        </div>`
      )}
    </div>`;
  }

  renderListView() {
    return html`
      ${ this.results.length || (this.results.length == 0 && this.sortLoading) ? html`
        <div class="row table-list-item table-list-head">
        ${this.columns.map((column, colIndex) =>
          html`
            ${column.type == 'thumbnail'?
              html`
                <div class="col-2 col-md-1">
                  <div class="thumbnail-wrapper">
                          &nbsp;
                  </div>
                </div>` :
              html`
                <div class="${column.class}" @click="${(e) => this._reloadResult(e, column.apiPropertyName, column.isSortable)}">
                  <div class="sort-head ${column.isSortable? 'sort-toggle' : 'no-sort'} ${this.sort.by == column.apiPropertyName? 'highlight': ''}">
                    <span class="${column.labelClass? column.labelClass : ''}"> ${this.translationDict[column.label] || column.label } </span>
                    ${column.shortLabel? html`<span class="${column.shortLabelclass}">${this.translationDict[column.shortLabel] || column.shortLabel }</span>` : ''}
                    ${column.isSortable == true ?
                      html`${this.sort.by == column.apiPropertyName ?
                        html`${this.sort.order == this.sort.desc ? html`<button class="button icon-small icon-circle tertiary"><i class="icon-font i16 tc-icon-arrow-line-down"></i></button>` : html`<button class="button icon-small icon-circle tertiary"><i class="icon-font i16 tc-icon-arrow-line-up"></i></button>` }`
                        : ''}`
                    : ''}
                  </div>
                </div>`
            }`
        )}
        ${this.menus.length ?
          html`<div class="col-2 col-md-1">
            <div>
                &nbsp;
            </div>
          </div>`: ''
        }
      </div>
      `: ''}
      ${this.results.map((item,i) => html`
        <div class="row table-list-item ${item.isActive? 'active': ''}  ${item.access === 'NO_ACCESS'? 'locked' : ''}" @click="${(e) => this._onItemClick(e, item, i)}">
          ${this.columns.map((column, colIndex) =>
            html`${column.type == 'thumbnail'?
              html`
                <div class="col-2 col-md-1">
                  <div class="thumbnail-wrapper">
                    ${this.isThumbnailAsImage(item) ?
                      html`<div class="thumbnail" style="background-image:url(${this.getThumbnailUrl(item, this.accessToken)})"></div>` :
                      html`<div class="thumbnail"> <img src="${this.defaultThumbnailImage}"/> </div>`
                    }
                  </div>
                </div>`
              :
              html`
                <div class="list-data ellipsis ${column.class}">
                  ${ (column.type == 'string' || column.type == 'number' || !column.type) ? html`<span>${ item[column.apiPropertyName] || this.getItemValue(item, column.apiPropertyName) }</span>` : ''}
                  ${column.type == 'date' ? html`<span>${this.formatDate(item[column.apiPropertyName] || this.getItemValue(item, column.apiPropertyName), "mm dd, yyyy")}</span>` : '' }
                  ${column.type == 'bytes' ? html`<span>${this.formatBytes( item[column.apiPropertyName] || this.getItemValue(item, column.apiPropertyName))}</span>` : '' }
                  ${column.displaySubTitle ?
                      html`<span class="${column.subTitleClass}">
                      ${this.translationDict[column.subTitleLabel]}&#58;
                      ${column.subTitleType == 'date' ?
                          html`${this.formatDate( item[column.subTitleApiPropertyName] || this.getItemValue(item, column.subTitleApiPropertyName), "mm dd, yyyy")}` :
                          html`${ item[column.subTitleApiPropertyName] || this.getItemValue(item, column.subTitleApiPropertyName) }`
                      }</span>`
                  : ''}
                </div>`
            }`
          )}

          ${this.menus.length ?
            html`<div class="col-2 col-md-1 flex-end">
              <div>
                <ul>
                  <li class="dropdown-pane-container" id="ddp-container-${i}">
                      <button class="button icon-medium icon-circle tertiary dropdownpane-link">
                        <i class="icon-font tc-icon-more-vert"></i>
                      </button>
                      <div class="dropdown-pane right is-open  list-dropdown">
                        <ul class="dropdown-list">
                          ${this.menus.map((menuItem, menuIndex) => html`
                            <li @click="${(e) => this._onMenuClick(e, item, menuItem.click_event_name)}"class="tooltip12 ellipsis" title="${this.translationDict[menuItem.label]}">${this.translationDict[menuItem.label]}</li>
                          `)}
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
            </div>`: ''
          }

          ${item.access === 'NO_ACCESS'?
            html`<div class="list-overlay">
              <div class="badge dark px-1 py-2">
                  <i class="icon-font i16 tc-icon-lock"></i>&nbsp;${this.translationDict["LOCKED"]}
              </div>
            </div>` : ''
          }
        </div>`
      )}`;
  }
  loadCssAndLangJson(assetPath) {
    this.defaultThumbnailImage = (this.defaultThumbnailImage && this.defaultThumbnailImage.indexOf("http") == -1 )? assetPath + this.defaultThumbnailImage : this.defaultThumbnailImage;
    loadCssForComponent(this, 'view-container', [this.resourcesUrl + '/fonts/icon-font.min.css']);
    //loadTranslationJson(this, assetPath, this.langCode, this.componentName, this.type, this.translationDict);
    this.requestUpdate('assetPath');
  }
  loadComponentConfig(config){
    this.translationDict = (config.translations)? Object.assign(this.translationDict, config.translations) : this.translationDict;
    if( config.translations && Object.keys(config.translations).length > 0) {
      this.requestUpdate('translationDict');
    }
    this.menus = config.menus || this.menus;
    this.columns = config.columns || this.columns;
    this.sort = config.sort || this.sort;
    this.noResultIconClass = config.noResultIconClass || this.noResultIconClass;

    this.displayThumbnailAsIcon = config.displayThumbnailAsIcon || this.displayThumbnailAsIcon;
    this.defaultThumbnailImage = config.defaultThumbnailImage || this.defaultThumbnailImage;
    this.defaultThumbnailImage = (this.defaultThumbnailImage && this.defaultThumbnailImage.indexOf("http") == -1 && this.assetPath && this.assetPath.indexOf("{{") == -1)? this.assetPath + this.defaultThumbnailImage : this.defaultThumbnailImage;
    this.includeScrollbar = (config.includeScrollbar !== undefined)? config.includeScrollbar : true;
    this.showCreateButton = (config.showCreateButton !== undefined)? config.showCreateButton : true;
    this.includeCustomHeaders = (config.includeCustomHeaders !== undefined)? config.includeCustomHeaders : this.includeCustomHeaders;
    this.responseKey = (config.responseKey !== undefined)? config.responseKey : this.responseKey;
    this.skipRangeInHeader = (config.skipRangeInHeader !== undefined)? config.skipRangeInHeader : this.skipRangeInHeader;
    this.skipBearerHeader = (config.skipBearerHeader !== undefined)? config.skipBearerHeader : this.skipBearerHeader;
    if( config.gridContainerCss && config.gridContainerCss != undefined) {
      this.gridContainerCss = config.gridContainerCss;
      this.requestUpdate('gridContainerCss');
    }
    if( config.gridCss && config.gridCss != undefined) {
      this.gridCss = config.gridCss;
      this.requestUpdate('gridCss');
    }
    this.requestUpdate('includeScrollbar');
    this.columns.forEach(function(column){
      if(column.id == 'thumbnail'){
        this.thumbnailColumn = column;
      } else if(column.id == 'name' || column.id == 'title'){
        this.titleColumn = column;
      }
    }.bind(this));
    this.requestUpdate('columns');
  }
  parentContainerHeightChanged(){
    if( this.results.length ) {
      resizeElementHeight(this.shadowRoot.querySelector('#view-inner-container'));
    } else {
      this.shadowRoot.querySelector('#view-inner-container').style.height = '100%';
    }
    this.dispatchEvent(new CustomEvent('on-container-height-changed', {detail: {
      'has-records': this.results.length
    }}));
  }
  moveSelectedItemToFirst(itemId){
    var itemIndex = this.results.findIndex(function(item){
      return item.id == itemId;
    });
    if( itemIndex > -1 ) {
      var selectedItems = this.results.splice(itemIndex, 1);
      this.results.unshift(selectedItems[0]);
      this.requestUpdate('results');
    }
  }
  highlightItem(highlightItemId){
    this.results.forEach(function(item){
      item.isActive = (item.id == highlightItemId);
    });
    this.requestUpdate('results');
  }
  highlightItemByIndex(itemIndex){
    this.results.forEach(function(item){
      item.isActive = false;
    });
    this.results[itemIndex].isActive = true;
    this.requestUpdate('results');
  }
  filterResultsByName(itemName) {
    this.results = this.resultsWOFilter.filter(function(item){
      return item.name.toLowerCase().indexOf(itemName.toLowerCase()) > -1;
    });
    this.requestUpdate('results');
  }
  firstUpdated(changedProps) {
    super.update(changedProps);
  }
  _reloadResult(e, column, isSortable) {
    if(isSortable){
      //var appendQueryString = '&sort=';
      this.sortLoading = true;
      this.sort.order = (this.sort.order == this.sort.desc)? this.sort.asc : this.sort.desc;
      this.sort.by = column;
      //var appendQueryString = (this.sortOrder == 'desc')? 'asc' : 'desc';
      //appendQueryString = appendQueryString + column;
      var appendQueryString = this.sort.queryFormat.replace("{SORT_ORDER}", this.sort.order).replace("{SORT_COLUMN}", column);
      var r = new RegExp(this.sort.regexForReplace);
      if( r.exec(this.apiUrl) !== null ){
        this.apiUrl = this.apiUrl.replace(r, appendQueryString);
      } else {
        this.apiUrl += appendQueryString;
      }
      this.startIndex = 0;
      this.isEndOfPage = false;
      this.results = [];
      this.getResults(null);
    }
  }
  getResults(accessToken, isInitialLoad){
    this.loading = true;
    var endIndex = (((this.startIndex/this.pageSize) + 1) * this.pageSize) - 1;
    var headers = {
      "Content-type": "application/json"
    };
    if( !this.skipBearerHeader ) {
      headers['Authorization'] = "Bearer " + (this.accessToken || accessToken)
    }
    if( this.skipRangeInHeader == 'false') {
      headers["Range"] = "items=" + this.startIndex +"-" + endIndex;
      headers["X-Range"] = "items=" + this.startIndex +"-" + endIndex;
    }
    if( Object.keys(this.includeCustomHeaders).length > 0 ) {
      Object.keys( this.includeCustomHeaders ).forEach(function(key){
        headers[key] = this.includeCustomHeaders[key];
      });
    }
    this.endTime = new Date();
    getRequestWithCallback("GET", this.apiUrl, headers, null, this.displayResults.bind(this, isInitialLoad));
  }
  updated(changedProps){
    super.updated(changedProps);
    if(changedProps.has('results') || changedProps.has('viewType') || changedProps.has('apiUrl')){
      JsForCss.initializeAll(this.shadowRoot.querySelector("#view-container"));
      if( this.results.length ){
        resizeElementHeight(this.shadowRoot.querySelector('#view-inner-container'));
      } else {
        this.shadowRoot.querySelector('#view-inner-container').style.height = '100%';
      }
    }
  }
  displayResults(isInitialLoad, event){
    if( (event.target.status == 200 || event.target.status == 206) && event.target.readyState == 4){
      //this.hideHeader = false;
      this.sortLoading = false;
      this.loading = false;
      var responseJson = JSON.parse(event.target.response);
      var pageItems = (this.responseKey)? responseJson[this.responseKey] : responseJson;
      if (isInitialLoad) {
        this.results = pageItems;
      } else {
        this.results = this.results.concat(pageItems);
      }
      this.dispatchEvent(new CustomEvent('on-page-items-loaded', {detail: {}}));
      this.dispatchEvent(new CustomEvent('on-container-height-changed', {detail:
        {
          'has-records': this.results.length
        }}));
      if( this.shadowRoot.querySelector("#view-inner-container") ) {
        JsForCss.initializeDropdownMenu(this.shadowRoot.querySelector("#view-inner-container"));
      }
      var contentRange = (this.skipRangeInHeader == 'false') ?event.target.getResponseHeader("content-range") : "";
      //resizeElementHeight(this.shadowRoot.querySelector('#view-inner-container'), this.windowHeight);
      if(event.target.status == 206){
        if(contentRange){
          var nextStartIndex = parseInt( contentRange.substring(contentRange.indexOf("/") +1) );
          var nextStartPage = this.startIndex + this.pageSize - 1;
          if(nextStartIndex >= nextStartPage) {
            this.startIndex = nextStartPage+1;
            this.loadNextPage = true;
            this.isEndOfPage = false;
            //this.getResults();
          } else {
            this.loadNextPage = false;
            this.isEndOfPage = true;
          }
        }
      } else {
        var totalItems = parseInt( contentRange.substring(contentRange.indexOf("/") +1) );
        this.loadNextPage = false;
        this.isEndOfPage = true && totalItems > 25;
      }
      this.resultsWOFilter = this.results;
      if( this.searchByName ) {
        this.filterResultsByName(this.searchByName);
      }
      if(this.selectedItemId) {
        this.highlightItem(this.selectedItemId);
      } else {
        this.requestUpdate('results');
      }
    } else if( event.target.readyState == 4 && event.target.status > 400 && event.target.status <= 500){
      this.loading = false;
      this.hideHeader = false;
      if(event.target.status != 416){
        this.results = [];
      }
      this.requestUpdate('results');
    }
  }
  _triggerScrollEnd() {
    if( this.loadNextPage ) {
      this.loading = true;
      this.isEndOfPage = false;
      this.requestUpdate('loading');
      JsForCss.initializeDropdownMenu(this.shadowRoot.querySelector("#view-inner-container"));
      resizeElementHeight(this.shadowRoot.querySelector('#view-inner-container'));
      this.hideHeader = false;
      this.getResults();
    }
  }
  _onScrollEnd(o){
      //visible height + pixel scrolled = total height
      if(this.includeScrollbar && (o.target.offsetHeight + o.target.scrollTop == o.target.scrollHeight))
      {
        this._triggerScrollEnd();
      }
  }
  _onItemClick(e, item, itemIndex){
    if( e.target.classList.contains('dropdownpane-link') || e.target.classList.contains('tc-icon-more-vert') ) {
      e.stopPropagation();
      this.shadowRoot.querySelectorAll(".dropdown-pane-container").forEach( (ddpElement) => {
        if( ddpElement.getAttribute("id") != 'ddp-container-' + itemIndex) {
          ddpElement.querySelector(".dropdown-pane").classList.remove("is-open");
          ddpElement.querySelector(".dropdownpane-link").classList.remove("active");
        }
      });
      this.shadowRoot.querySelector("#ddp-container-" + itemIndex + " .dropdown-pane").classList.toggle('is-open');
      this.shadowRoot.querySelector("#ddp-container-" + itemIndex + " .dropdownpane-link").classList.toggle('active');
      return false;
    } else if( e.target.classList.contains('tooltip12') ) {
      //e.stopPropagation();
      return true;
    } else if(item.access !== 'NO_ACCESS') {
      if( this.allowMultipleSelect == 'true' ) {
        this.results[itemIndex].isActive = !this.results[itemIndex].isActive;
        this.requestUpdate('results');
        var selectedItems = [];
        this.results.forEach(function(item){
          if( item.isActive ) {
            selectedItems.push(item);
          }
        });
        this.dispatchEvent(new CustomEvent('on-select-items',
          { detail: selectedItems }));
      } else {
        if( item.id ) {
          this.selectedItemId = item.id;
          this.highlightItem(this.selectedItemId);
        } else {
          this.highlightItemByIndex(itemIndex);
        }
      }
    }
    this.dispatchEvent(new CustomEvent('on-item-click', {detail: item}));
  }
  _onMenuClick(e, item, eventName){
    e.stopPropagation();
    e.preventDefault();
    this.dispatchEvent(new CustomEvent(eventName, {detail: item}));
    JsForCss.toggleDropdown(e, this.shadowRoot.querySelector("#view-container"), true);
  }
  getThumbnailUrl(item, accessToken){
    var thumbnailUrl = item[this.thumbnailColumn.apiPropertyName];
    var callbackUrl = this.thumbnailColumn.callbackUrl;
    if(thumbnailUrl && thumbnailUrl.indexOf("http") === 0){
        return thumbnailUrl + "&accessToken=" + this.accessToken || accessToken;
    } else {
      return callbackUrl + ( (this.setDefaultThumbnailImage)? this.setDefaultThumbnailImage : thumbnailUrl );
    }
  }
  getDefaultThumbnailUrl(){
    return (this.defaultThumbnailImage && this.defaultThumbnailImage.indexOf("http") == -1 )? this.assetPath + this.defaultThumbnailImage : this.defaultThumbnailImage;
  }
  isThumbnailAsImage(item){
    return (item[this.thumbnailColumn.apiPropertyName] && item[this.thumbnailColumn.apiPropertyName].indexOf("http") === 0 && item.access != 'NO_ACCESS');
  }
  formatBytes(bytes) {
    return customFilters.formatBytes(bytes);
  }
  formatDate(date, format) {
    return customFilters.formatDate(date, format);
  }
  getItemValue( item, key ) {
    var tmpKeys = key.split(".");//it should have only three depth
    if( tmpKeys.length == 1 ) {
      return item[key];
    } else if( tmpKeys.length == 2 ) {
      return item[tmpKeys[0]][tmpKeys[1]];
    } else if( tmpKeys.length === 3 ) {
      return item[tmpKeys[0]][tmpKeys[1]][tmpKeys[2]];
    } else {
      return '';
    }
  }
  updateExternalCss(externlCssUrl) {
    loadCssForComponent(this, 'view-container', [this.resourcesUrl + '/fonts/icon-font.min.css', externlCssUrl]);
  }
}

window.customElements.define('list-tile-view', ListTileView);

export default ListTileView;
window.ListTileView = ListTileView;